import React from 'react';
import { Outlet } from 'react-router';
import styled from 'styled-components';
import { useExternalFeatureListener } from '../shared/useExternalFeatureListener';

const StyledFlowLayout = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  width: 100vw;
  height: 100vh;
  border-radius: 1.25rem;
  border: 1px solid #e9e7e4;
`;

export function FlowLayout() {
  useExternalFeatureListener();

  return (
    <StyledFlowLayout>
      <Outlet />
    </StyledFlowLayout>
  );
}
